import { attachmentPath } from '../urls';

// Side-effect-free logic behind the appointment row "view attachments" action, extracted from
// AppointmentTabSelector so it can be unit-tested.

// The action is only shown for a row that actually has attachments.
export const shouldDisplayAttachments = ({ attachmentIds } = {}) => Boolean(attachmentIds && attachmentIds.length > 0);

// Clicking the action opens the attachments modal for the appointment by navigating to its hash route
// (consumed by the RoutedModal that renders AppointmentAttachments).
export const getAttachmentModalHash = (id) => `#${attachmentPath}/${id}`;

// The row action descriptor handed to the appointments grid. Built here (rather than inline in the
// component) so a test can pin the wiring: that the action's visibility is gated on
// shouldDisplayAttachments and that clicking it navigates to the attachments modal hash for the row.
export const buildViewAttachmentsAction = (t, navigate) => ({
  key: 'view-attachments',
  text: t('viewAttachments'),
  icon: 'attachment',
  onClick: ({ id }) => navigate(getAttachmentModalHash(id)),
  renderWhen: shouldDisplayAttachments,
});
